/* eslint-disable import/no-cycle */
/* eslint-disable no-console */
/* eslint-disable no-restricted-syntax */
import ga from '../../../../helpers/ga';
import { pipeline } from '..';
import { LVTMetricCheckoutAnalysisStep } from '../../types';

/* eslint-disable class-methods-use-this */
export class TrackingPrimitives {
  // Due to switching parts of the app sometimes events from dataLayer could be lost.
  // That's why they are needed to be repushed on next page load
  addCheckoutAnalysisEventListener(
    stepName: LVTMetricCheckoutAnalysisStep,
    storageNameGetter: (key: string) => string
  ): this {
    if (ga.checkLVTMetricEventExistence(stepName)) return this;
    const gaEventString = sessionStorage.getItem(storageNameGetter(stepName));
    if (!gaEventString) {
      console.warn('gaEventString was not found in session storage, skipping');
      return this;
    }
    try {
      const gaEvent = JSON.parse(gaEventString);
      pipeline.flow.primitives.addCheckoutStepEvent(stepName, gaEvent.data);

      return this;
    } catch (err) {
      console.error('GA Event (session storage) parsing failed');
      return this;
    }
  }

  listenForFeatures<T extends LVTMetricCheckoutAnalysisStep>(
    ...steps: (
      | (T extends `${infer Step}_entry` ? Step : never)
      | (T extends `${infer Step}_add_to_basket` ? Step : never)
    )[]
  ): this {
    for (const step of steps) {
      this.addCheckoutAnalysisEventListener(
        `${step}_entry` as LVTMetricCheckoutAnalysisStep,
        pipeline.storage.exit
      );
      this.addCheckoutAnalysisEventListener(
        `${step}_add_to_basket` as LVTMetricCheckoutAnalysisStep,
        pipeline.storage.exit
      );
      this.addCheckoutAnalysisEventListener(
        `${step}_add_to_basket` as LVTMetricCheckoutAnalysisStep,
        pipeline.storage.entry
      );
    }
    return this;
  }

  abandoned(): void {
    if (ga.checkLVTMetricEventExistence('checkout_abandoned')) return;

    const sessionId = pipeline.storage.getLocalStorageItem('sessionId');
    if (!sessionId) {
      console.warn('Metrics: sessionId was not found');
      return;
    }

    const lastStepReached =
      pipeline.storage.getLocalStorageItem('stepName') || undefined;

    const data = {
      sessionId,
      lastStepReached,
      timestamp: Date.now(),
      abandonedCheckout: true,
    };

    pipeline.flow.primitives.addAbandonedCheckoutStepEvent(data);
    pipeline.storage.cleanUp();
  }
}
